<template>
  <section class="app-main">
    <transition name="fade-transform" mode="out-in">
      <!-- or name="fade" -->
      <div class="main-router-wrapper">
        <keep-alive>
          <router-view v-if="keepAlive" />
        </keep-alive>
        <router-view v-if="!keepAlive" />
      </div>
    </transition>
  </section>
</template>

<script>
export default {
  name: "AppMain",
  data() {
    return {};
  },
  computed: {
    keepAlive() {
      return this.$route.meta.keepAlive;
    },
    key() {
      return this.$route.name !== undefined
        ? this.$route.name + +new Date()
        : this.$route + +new Date();
    }
  }
};
</script>

<style scoped>
.app-main {
  /*50 = navbar  35 = tag*/
  min-height: calc(100vh - 50px - 35px);
  position: relative;
  overflow: hidden;
}

.main-router-wrapper {
  padding: 10px 10px 3rem;
}
</style>
